// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__kTUqV","footer":"Form_footer__Xsqde"};